<template>
  <div id="app">
    <Nav></Nav>
    <router-view class="main-content"></router-view>
    <Bottom @show-cookie-settings="showCookieSettings"></Bottom>
    <Weixin></Weixin>
    <Cookie ref="cookie_settings"></Cookie>
  </div>
</template>

<script>
import Nav from './components/Nav';
import Bottom from './components/Bottom';
import Weixin from './components/Weixin';
import Cookie from './components/Cookie';
export default {
  name: 'app',
  components: {
    Nav,
    Bottom,
    Weixin,
    Cookie,
  },
  methods: {
    showCookieSettings() {
      this.$refs.cookie_settings.showCookieDetail()
    }
  }
}
</script>

<style lang="less">
@import url('./assets/style/common.less');
@import url('./assets/style/colors.less');
html,body{
  margin:0;
  padding:0;
  background-color: rgb(22,19,88);
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(22,19,88);
  text-align: center;
  color: #2c3e50;
  width: 100%;
  margin: 0 auto;
  background-image: url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/all_bg.jpg');
  background-size: 100%;
  background-repeat: round;
  overflow-x: hidden;
}
.el-submenu__title{
  height: 50px;
}
@media screen and (max-width: 992px) {
  html,body{
    width: 100%;
    height: 100%;
    background-image: url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/all_bg.jpg');
  }
  #app {
    // height: 100%;
    background-repeat: initial;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue